import Typography from '@common_typography';
import Dialog from '@common_dialog';
import Link from 'next/link';
import cx from 'classnames';
import Button from '@common_button/index';
import XMarkIcon from '@heroicons/react/24/solid/XMarkIcon';

const ModalProductCompare = (props) => {
    const { open, setOpen, t } = props;
    return (
        <>
            <Dialog
                open={open}
                closeOnBackdrop
                classTitle="!text-2xl !font-bold text-primary leading-6w-full text-center  "
                classContainer="!max-w-[420px] relative"
                classWrapperTitle="!rounded-none !pt-5 flex-col-reverse"
                classContent="!rounded-none !px-5 !pb-10"
                useCloseTitleButton={false}
                content={(
                    <>
                        <Button
                            onClick={() => setOpen()}
                            iconOnly
                            className={
                                cx(
                                    'swift-button-close-dialog',
                                    'absolute top-[5px] right-[-5px]',
                                )
                            }
                            variant="plain"
                            icon={<XMarkIcon className="h-[24] w-[24]" />}
                        />
                        <div className="dialog-title mb-[15px] mt-[5px]">
                            <Typography variant="p-2" className="!text-2xl !font-bold text-primary leading-6w-full text-center">
                                {t('catalog:productCompare:dialogTitle')}
                            </Typography>
                        </div>
                        <Typography variant="p-2" className="!text-[15px] !text-neutral-500 !leading-[22px] !font-medium text-center mb-5">
                            {t('catalog:productCompare:dialogMessage')}
                        </Typography>
                        <Link href="/catalog/product_compare" className="flex justify-center">
                            <Typography
                                variant="p-3"
                                className={cx(
                                    'bg-yellow-300 hover:bg-yellow-500 transition-all duration-300 text-primary uppercase ',
                                    '!text-[13px] font-bold w-fit px-[31px] py-[1px] leading-[38px] text-center',
                                )}
                            >
                                {t('catalog:productCompare:dialogButton')}
                            </Typography>
                        </Link>
                    </>
                )}
            />
        </>
    );
};

export default ModalProductCompare;
